import NumberControl from './number-control';

export default NumberControl;